var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-animation"},[_c('VerticalImage',{attrs:{"animation":_vm.animation,"background":_vm.background,"loop":_vm.loop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }